translations:
  page_not_found:
    en: "Page not found."
    nl: "Pagina niet gevonden."
  page_not_found_description:
    en: "This page might have moved to somewhere else. Try searching through the projects on the homepage."
    nl: "Deze pagina is misschien verplaatst. Probeer te zoeken door de projecten op de homepage."
  page_not_found_button:
    en: "Return to homepage"
    nl: "Terug naar homepage"
  project_not_found:
    en: "Project not found."
    nl: "Project niet gevonden."
  no_projects_found:
    en: "No projects found."
    nl: "Geen projecten gevonden."
  started:
    en: "Started"
    nl: "Gestart"
  finished:
    en: "Finished"
    nl: "Gereed"
  lastUpdated:
    en: "Last updated"
    nl: "Laatst aangepast"
  source:
    en: "Source"
    nl: "Bron"
  launch_app:
    en: "Launch app"
    nl: "App starten"
  info:
    en: "Info"
    nl: "Informatie"
  homepage:
    en: "Homepage"
    nl: "Homepage"
  search:
    en: "Search"
    nl: "Zoeken"
  timeline:
    en: "Timeline"
    nl: "Tijdlijn"
  contact:
    en: "Contact"
    nl: "Contact"
  email:
    en: "Email"
    nl: "E-mail"
  name: Ruben van Dijk
  title: Ruben's apps
emailData: {"\t":"u","\u0004":"a","\n":"b","\u0003":"t","\u0002":"n","\u0001":"o","\u000e":".","\f":"n","\u0007":"@","\r":"d","\u0010":"l","\u0005":"c","\u000b":"e","\b":"r","\u000f":"n","\u0000":"c","\u0006":"t"}
items:
- id: geoextension
  name:
    en: Geocaching Extension
    nl: Geocaching Extensie
  source: https://gitlab.rubend.nl/tools/geoextension
  dates:
    started: 2016-04-17
    finished: 2022-12-23
  description:
    en: A browser extension that helps with logging geocaches. It can automatically fill in the log form.
    nl: Een browser extensie die helpt bij het loggen van geocaches. Hij kan het logformulier automatisch invullen.
  images:
    thumbnail:
      icon: mdiMathLog
  tags:
    - geocaching
    - extension
- id: vier
  name:
    en: Connect Four
    nl: 4 op een rij
  url: https://vier.rubend.nl
  source: https://gitlab.rubend.nl/games/4
  dates:
    started: 2019
    finished: 2019
  description:
    en: Connect 4!
    nl: 4 op een rij!
  images:
    thumbnail: 'data:image/svg+xml,<svg width="4" height="5" xmlns="http://www.w3.org/2000/svg"><circle cx="1" cy="1" r="1" fill="blue"/><circle cx="3" cy="1" r="1" fill="red"/><circle cx="1" cy="3" r="1" fill="red"/><circle cx="3" cy="3" r="1" fill="blue"/><text x="2" y="5" font-size="1" text-anchor="middle">4</text></svg>'
    spinner:
      - 4-first.jpg
  tags:
    - games
    - nodejs
- id: rolit
  name: Rolit
  url: https://rolit.rubend.nl
  source: https://gitlab.rubend.nl/games/rolit
  dates:
    started: 2019
    finished: 2019
  description: Rolit!
  images:
    thumbnail: 'data:image/svg+xml,<svg width="4" height="5" xmlns="http://www.w3.org/2000/svg"><circle cx="1" cy="1" r="1" fill="blue"/><circle cx="3" cy="1" r="1" fill="red"/><circle cx="1" cy="3" r="1" fill="green"/><circle cx="3" cy="3" r="1" fill="yellow"/><text x="2" y="5" font-size="1" text-anchor="middle">ROLIT</text></svg>'
  tags:
    - games
    - nodejs
- id: skipbo
  name: Skipbo
  url: https://skipbo.rubend.nl
  source: https://gitlab.rubend.nl/games/skipbo
  dates:
    started: 2019
    finished: 2019
  description: Skipbo!
  images:
    thumbnail: '/skipbo.jpg'
  tags:
    - games
    - nodejs
- id: whereigo-cracker
  name: Wherigo cracker
  url: https://whereigo.rubend.nl
  source: https://gitlab.rubend.nl/tools/whereigo
  dates:
    started: 2019-07-02
    finished: 2022-12-11
  description:
    en: Solves [Wherigo](https://wherigo.com/) cartridges by decompiling them.
    nl: Lost [Wherigo](https://wherigo.com/) cartridges op door ze te decompileren.
  images:
    thumbnail: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="18"><circle cx="8" cy="8" r="7" fill="%2312508c" stroke="%23000000" stroke-width="0.5"></circle><polygon points="5,7.5 8.5,11 11,5 5,7.5" style="fill:white;"></polygon><text x="8" y="18" font-size="3" text-anchor="middle">WHERIGO</text></svg>'
  tags:
    - geocaching
    - nodejs
- id: super-wonder-captain
  name: Super Wonder Captain
  source: https://gitlab.rubend.nl/school/jaar1/super-wonder-captain
  dates:
    started: 2019-10-28
    finished: 2019-11-02
  description:
    en: Super wonder captain! This was my first group project for school. It's a game where you have to guess what the name of a Marvel character is.
    nl: Super wonder captain! Dit was mijn eerste groepsproject voor school. Het is een spel waarbij je moet raden welke Marvel personage het is.
  images:
    thumbnail: '/superwondercaptain.webp'
  tags:
    - python
    - university
    - year1
- id: rooster
  name:
    en: Schedule
    nl: Rooster
  url: https://rooster.rubend.nl
  source: https://gitlab.rubend.nl/tools/rooster
  dates:
    started: 2020-02-27
    finished: 2022-06-19
  description:
    en: Parses [iCalendar](https://en.wikipedia.org/wiki/ICalendar) files from websites, and removes the events that are not relevant to you. Can also do some text replacing to fix bad automated systems.
    nl: Verwerkt [iCalendar](https://en.wikipedia.org/wiki/ICalendar) bestanden van websites, en verwijdert de items die niet relevant voor je zijn. Kan ook tekst vervangen om slechte automatische systemen te fixen.
  images:
    thumbnail:
      icon: mdiCalendarFilter
  tags:
    - nodejs
- id: pris
  name: PRIS
  source: https://gitlab.rubend.nl/school/jaar1/pris
  dates:
    started: 2020-02-05
    finished: 2020-04-08
  description:
    en: PRIS is a program to track student presence or absence. This was my second group project for school.
    nl: PRIS is een programma om student aanwezigheid of afwezigheid bij te houden. Dit was mijn tweede groepsproject voor school.
  images:
    thumbnail:
      icon: mdiAccountSchool
  tags:
    - java
    - university
    - year1
- id: clonebook
  name: Clonebook
  url: https://clonebook.rubend.nl
  source: https://gitlab.rubend.nl/tools/clonebook
  dates:
    started: 2020-04-21
    finished: 2020-06-29
  images:
    thumbnail: '/clonebook.svg'
  description:
    en: Clonebook is a clone of Facebook. This was my first "large" java project. The code quality is garbage, but that's because I didn't know any better. It doesn't use any frameworks, just plain old servlets. If I would rewrite this... I would use Spring Boot and Kotlin, with a Vue frontend.
    nl: Clonebook is een clone van Facebook. Dit was mijn eerste "grote" java project. De code kwaliteit is bagger, maar dat komt omdat ik nog niet wist hoe het beter kon. Het gebruikt geen frameworks, gewoon ouderwetse servlets. Als ik dit zou herschrijven... zou ik Spring Boot en Kotlin gebruiken, met een Vue frontend.
  tags:
    - university
    - year1
    - java
- id: billy
  name: Billy
  source: https://gitlab.rubend.nl/school/jaar2/billy
  url: https://billy.rubend.nl
  dates:
    started: 2020-11-09
    finished: 2021-01-20
  description:
    en: Billy is a wiki designed for HBO-ICT students, about HBO-I. This was our group project for Frontend development 2.
    nl: Billy is een wiki ontworpen voor HBO-ICT studenten, over HBO-I. Dit was ons groepsproject voor Frontend development 2.
  images:
    thumbnail: '/billy.webp'
  tags:
    - university
    - year2
- id: botbot
  name: BotBot
  source: https://gitlab.rubend.nl/tools/botbot
  dates:
    started: 2021-02-19
    finished: 2022-11-21
  description:
    en: BotBot is a bot for Discord. It's written in Node.JS, and uses the [discord.js](https://discord.js.org/#/) library.
    nl: BotBot is een bot voor Discord. Het is geschreven in Node.JS, en gebruikt de [discord.js](https://discord.js.org/#/) library.
  images:
    thumbnail:
      icon: mdiMessageFlash
- id: tetris
  name: Tetris
  source: https://gitlab.rubend.nl/school/jaar2/tetris
  url: https://tetris.rubend.nl
  dates:
    started: 2021-05-21
    finished: 2021-06-15
  description:
    en: Tetris! This was my first project large in dotnet. It's multi-player and multi-room.
    nl: Tetris! Dit was mijn eerste grote project in dotnet. Het is multi-player en multi-room.
  images:
    thumbnail: 'data:image/svg+xml,<svg width="3" height="3" xmlns="http://www.w3.org/2000/svg"><rect fill="purple" width="3" height="1" y="1"/><rect fill="purple" width="1" height="1" x="1"/></svg>'
  tags:
    - dotnet
    - university
    - year2
- id: lalaland
  name: Lalaland
  source: https://gitlab.rubend.nl/school/jaar2/lalaland
  url: https://lalaland.rubend.nl
  dates:
    started: 2021-04-04
    finished: 2021-06-28
  images:
    thumbnail: /lalaland.webp
  description:
    en: This is by far my largest group project. It's a festival website, written in Java and Vue(tify).
    nl: Dit is veruit mijn grootste groepsproject. Het is een festival website, geschreven in Java en Vue(tify).
  tags:
    - java
    - vue
    - university
    - year2
- id: mens-erger-je-niet
  name:
    nl: Mens erger je niet!
    en: Don't Get Angry!
  url: https://mens-erger-je-niet.rubend.nl
  source: https://gitlab.rubend.nl/games/mens-erger-je-niet
  dates:
    started: 2021-12-29
    finished: 2022-01-02
  description:
    en: Don't Get Angry!
    nl: Mens erger je niet!
  images:
    thumbnail: '/mens-erger-je-niet.svg'
  tags:
    - games
    - nodejs
- id: wifilogin
  name: Wifilogin
  source: https://gitlab.rubend.nl/tools/android/wifilogin
  dates:
    started: 2022-08-21
    finished: 2022-09-01
  description:
    en: This app logs you in to your network with a login button, like at school, in a restaurant, or in the train. It's written in Kotlin, and compatible with nearly every platform.
    nl: Deze app logt je in op je netwerk met een login knop, zoals op school, in een restaurant, of in de trein. Het is geschreven in Kotlin, en werkt op bijna elk platform.
  images:
    thumbnail:
      icon: mdiWifiStrength4LockOpen
  tags:
    - android
    - linux
    - windows
    - macos
    - kotlin
- id: zwemapp
  name: Zwemapp
  source: https://gitlab.rubend.nl/tools/android/zwemmen
  dates:
      started: 2022-10-03
      finished: 2022-10-10
  description:
    en: This app can be used view your swimming times, if available on [Swimtimes.nl](https://swimtimes.nl). It's written in Kotlin. It uses my own [backend](https://gitlab.rubend.nl/tools/swimming/swimtimes) to parse the HTML serverside. A earlier version of this app using the same backend was made with the [AI2 app inventor](https://ai2.appinventor.mit.edu/) in 2016.
    nl: Deze app kan gebruikt worden om je zwemtijden te bekijken, als ze beschikbaar zijn op [Swimtimes.nl](https://swimtimes.nl). Het is geschreven in Kotlin. Het gebruikt mijn eigen [backend](https://gitlab.rubend.nl/tools/swimming/swimtimes) om de HTML serverside te verwerken. Een eerdere versie van deze app met dezelfde backend is gemaakt met de [AI2 app inventor](https://ai2.appinventor.mit.edu/) in 2016.
  images:
    thumbnail: '/zwemapp.png'
  tags:
  - android
  - swimming
  - kotlin
  - nodejs
- id: paywall
  name: Paywall redirect
  source: https://gitlab.rubend.nl/tools/android/paywall
  dates:
    started: 2022-06-11
    finished: 2022-06-11
  description:
    en: This app redirects you to 12ft.io to get around the paywall of a website, so you can read the article. It's written in Java. This was mainly a exercise to see how small I could get a app. It doesn't have any dependencies, compatible with every Android version, and only 1 functional line. Compiled to a APK it's only 9.19KB!
    nl: Deze app stuurt je door naar 12ft.io om de paywall van een website te omzeilen, zodat je het artikel kunt lezen. Het is geschreven in Java. Dit was vooral een oefening om te zien hoe klein ik een app kon krijgen. Het heeft geen afhankelijkheden, is compatibel met elke Android-versie, en heeft maar 1 functionele regel. Gecompileerd naar een APK is het slechts 9,19KB!
  images:
    thumbnail:
      icon: mdiCurrencyUsdOff
  tags:
    - android
    - java
- id: zwemtijden
  name: Zwemtijden
  source: https://gitlab.rubend.nl/tools/swimming/zwemtijden
  dates:
    started: 2022-02-26
    finished: 2023-01-24
  description:
    en: Generates graphs from swimming results in the browser with R. Graphs made by [Berinda](https://gitlab.rubend.nl/Berinda). The backend code itself is written by me. The [dataprovider](https://gitlab.rubend.nl/tools/swimming/swimrankings) is written by me, in node.js. It parses data from [Swimrankings](https://swimrankings.net)
    nl: Genereert grafieken van zwemresultaten in de browser met R. Grafieken gemaakt door [Berinda](https://gitlab.rubend.nl/Berinda). De backend code zelf is geschreven door mij. De [dataprovider](https://gitlab.rubend.nl/tools/swimming/swimrankings) is geschreven door mij, in node.js. Hij verwerkt data van [Swimrankings](https://swimrankings.net)
  tags:
    - swimming
    - nodejs
    - R
  images:
    thumbnail:
      icon: mdiSwim
      color: turquoise
- id: libvirtmanager
  name: VM Manager
  source: https://gitlab.rubend.nl/tools/libvirtmanager
  dates:
    started: 2022-04-08
    finished: 2022-08-04
  description:
    en: This is a web interface for managing VMs on a libvirt server. It's written in Java and Vue.
    nl: Dit is een webinterface voor het beheren van virtuele machines op een libvirt-server. Het is geschreven in Java en Vue.
  images:
    thumbnail:
      icon: mdiRemoteDesktop
  tags:
    - java
    - vue
- id: k3s-generator
  name: k3s-generator
  source: https://gitlab.rubend.nl/tools/infra/k3s-generator
  url: https://k3s-generator.rubend.nl
  dates:
    started: 2022-11-25
    finished: 2022-12-31
  description:
    en: This is a tool to generate a k3s/k8s yml file from very simple input. It's made to make deploying a Docker image as easy as possible, with just 4 lines of config required. It's written in Javascript.
    nl: Dit is een tool om een k3s/k8s yml-bestand te genereren van een heel simpele input. Het is gemaakt om het uitrollen van een Docker image zo eenvoudig mogelijk te maken, met slechts 4 regels configuratie vereist. Het is geschreven in Javascript.
  images:
    thumbnail:
      icon: mdiCogBox
      color: '#326ce5'
  tags:
  - k8s
  - nodejs
- id: updater
  name: Updater
  source: https://gitlab.rubend.nl/tools/infra/updater
  dates:
    started: 2022-12-09
    finished: 2023-01-18
  description:
    en: This is a tool to update a k3s/k8s deployment with a new Docker image, by sending a automated request to the server. It's written in Node.JS.
    nl: Dit is een tool om een k3s/k8s deployment te updaten met een nieuwe Docker image, door een geautomatiseerde aanvraag naar de server te sturen. Het is geschreven in Node.JS.
  images:
    thumbnail:
      icon: mdiUpdate
      color: lightblue
  tags:
    - k8s
- id: rquery
  name: RQuery
  url: https://rquery.rubend.nl/
  source: https://gitlab.rubend.nl/libraries/rquery
  dates:
    started: 2022-12-23
    finished: 2022-12-23
  description:
    en: A tiny jQuery clone with only the stuff I need. It's less than 1kb when minified.
    nl: Een kleine jQuery kloon met alleen de dingen die ik nodig heb. Het is minder dan 1kb wanneer het is geminified.
  images:
    thumbnail: /rquery.svg
- id: rubend
  name: Rubend.nl homepage
  url: https://rubend.nl
  source: https://gitlab.rubend.nl/internal/rubend
  dates:
    started: 2023-01-20
    finished: 2024-07-07
  description:
    en: This is the homepage of rubend.nl. It's only a frontend application. It's written in Vue and Vuetify.
    nl: Dit is de homepage van rubend.nl. Het is alleen een frontend applicatie. Het is geschreven in Vue en Vuetify.
  images:
    thumbnail:
      icon: mdiRobotConfused
  tags:
    - vue
- id: zeroscale
  name: ZeroScale
  source: https://gitlab.rubend.nl/tools/infra/zeroscale
  dates:
      started: 2023-04-15
      finished: 2023-04-6
  description:
      en: Scales down services to 0 replicas when they are not used. Written in TS/Node.JS.
      nl: Schaal services naar 0 replicas wanneer ze niet worden gebruikt. Geschreven in TS/Node.JS.
  images:
    thumbnail:
      icon: mdiElectricSwitch
      color: red
  tags:
      - typescript
      - nodejs
- id: queuetimes
  name:
    nl: Wachttijden
    en: Queuetimes
  source: https://gitlab.rubend.nl/tools/android/queuetimes
  dates:
    started: 2023-07-10
    finished: 2023-07-12
  description:
    en: This app shows the queue times of multiple theme parks around the world, using the [QueueTimes](https://www.queuetimes.com/) API. It's written in Kotlin.
    nl: Deze app toont de wachttijden van meerdere pretparken over de hele wereld, met behulp van de [QueueTimes](https://www.queuetimes.com/) API. Het is geschreven in Kotlin.
  images:
    thumbnail:
      icon: mdiClockTimeFour
  tags:
    - android
    - kotlin
- id: pdf
  name: PDF
  source: https://gitlab.rubend.nl/tools/pdf
  dates:
    started: 2023-08-05
    finished: 2023-08-06
  description:
    en: A tool to merge and split PDF files in different methods. Written in Node.JS. Uses the Linux pdftk command.
    nl: Een tool om PDF bestanden te mergen en splitten op verschillende manieren. Geschreven in Node.JS. Gebruikt het Linux pdftk commando.
  images:
    thumbnail:
      icon: mdiFilePdfBox
  tags:
    - nodejs
- id: ov
  name: OV
  url: https://ov.rubend.nl
  source: https://gitlab.rubend.nl/tools/ov/ov
  dates:
    started: 2023-02-05
    finished: 2023-09-17
  description:
    en: Travelplanner for the Dutch public transit network.
    nl: Reisplanner voor het Nederlandse openbaar vervoer.
  images:
    thumbnail:
      icon: mdiTrain
  tags:
    - vue
    - typescript
    - graphql
- id: AOC
  name: Advent of Code
  source: https://gitlab.rubend.nl/tools/aoc
  dates:
    started: 2023-12-01
  description:
    en: My Advent of Code solutions. Written in Typescript.
    nl: Mijn Advent of Code oplossingen. Geschreven in Typescript.
  images:
    thumbnail:
      icon: mdiStarFace
  tags:
    - typescript
- id: swimtimer
  name: Swimtimer
  source: https://gitlab.rubend.nl/tools/android/zwemtimer
  dates:
    started: 2023-12-23
    finished: 2023-12-24
  description:
    en: A timer for swimming training, for Android. Written in Kotlin.
    nl: Een timer voor zwemtrainingen, voor Android. Geschreven in Kotlin.
  images:
    thumbnail:
      icon: mdiSwim
  tags:
  - android
  - kotlin
- id: ovRepeater
  name: OV Repeater
  source: https://gitlab.rubend.nl/tools/ov/ovrepeater
  description:
    en: A helper for my OV application which provides live data. Made this because Typescript was consuming too much CPU for my liking.
    nl: Helper applicatie voor mijn OV applicatie, voor de live data. Ik heb dit gemaakt omdat Typescript teveel CPU gebruikte.
  dates:
    started: 2024-04-19
    finished: 2024-04-22
  tags:
  - rust
- id: vite-gql-codegen
  name: vite-graphql-codegen-optimized
  source: https://gitlab.rubend.nl/libraries/vite-plugin-graphql-codegen-optimized
  description:
    en: A vite plugin to automatically generate GraphQL types from a GraphQL schema. It's written in TypeScript. It's closely related to [vite-plugin-graphql-codegen](https://github.com/danielwaltz/vite-plugin-graphql-codegen), but with a few improvements. It's used in my [OV](/project/ov) project.
    nl: Een vite plugin om GraphQL types automatisch te genereren van een GraphQL schema. Het is geschreven in TypeScript. Het doet bijna hetzelfde als [vite-plugin-graphql-codegen](https://github.com/danielwaltz/vite-plugin-graphql-codegen), maar met enkele verbeteringen.Het wordt gebruikt in mijn [OV](/project/ov) project.
  dates:
    started: 2024-06-22
  tags:
    - typescript
    - library
    - graphql
- id: rate-cache
  name: Rate limit proxy
  source: https://gitlab.rubend.nl/tools/rate-cache
  description:
    en: Simple script that downloads and provides a hardcoded list of rate limited downloads. Quick and dirty, written in just 1 hour.
    nl: Een eenvoudige script die een hardcoded lijst met rate limited downloads biedt. Snel, maar niet netjes, geschreven in slechts 1 uur.
  dates:
    started: 2024-11-19
    finished: 2024-11-19
  images:
    thumbnail:
      icon: mdiDownloadNetworkOutline
  tags:
    - nodejs
- id: flux
  name: Flux
  source: https://gitlab.rubend.nl/tools/infra/flux
  description:
    en: My k3s cluster is automatically deployed from a git repository. It uses [Flux](https://fluxcd.io/) under the hood. This repository contains everything in the cluster.
    nl: Mijn k3s cluster wordt automatisch uitgerold vanuit een git repository. Hier wordt [Flux](https://fluxcd.io/) voor gebruikt. Deze repository bevat alles in het cluster.
  dates:
    started: 2025-07-01
  images:
    thumbnail:
      icon: mdiAllInclusive
  tags:
    - k8s
- id: charts
  name: Charts
  source: https://gitlab.rubend.nl/tools/infra/charts
  description:
    en: A Helm chart repository for my k3s cluster. It contains charts for some of my own projects, and some third party charts that I use.
    nl: Een Helm chart repository voor mijn k3s cluster. Het bevat charts voor enkele van mijn eigen projecten, en enkele third party charts die ik gebruik.
  dates:
    started: 2025-07-31
  images:
    thumbnail:
      icon: mdiShipWheel
  tags:
    - k8s
    - library

tags:
  - id: android
    name: Android
    icon: mdiAndroid
  - id: dotnet
    name: '.NET'
    icon: mdiDotNet
  - id: extension
    name:
      en: Browser extension
      nl: Browser extensie
    icon: mdiWeb
  - id: games
    name: Games
    icon: mdiGamepadVariant
  - id: geocaching
    name: Geocaching
  - id: graphql
    name: GraphQL
    icon: mdiGraphql
  - id: java
    name: Java
    icon: mdiLanguageJava
  - id: k8s
    name: Kubernetes
    icon: mdiKubernetes
  - id: kotlin
    name: Kotlin
    icon: mdiLanguageKotlin
  - id: linux
    name: Linux
    icon: mdiLinux
  - id: macos
    name: macOS
    icon: mdiApple
  - id: nodejs
    name: Node.JS
    icon: mdiNodejs
  - id: python
    name: Python
    icon: mdiLanguagePython
  - id: R
    name: R
    icon: mdiLanguageR
  - id: swimming
    name: Swimming
    icon: mdiSwim
  - id: typescript
    name: TypeScript
    icon: mdiLanguageTypescript
  - id: university
    name: University
    icon: mdiSchool
  - id: vue
    name: Vue
    icon: mdiVuejs
  - id: windows
    name: Windows
    icon: mdiMicrosoftWindows
  - id: year1
    name:
      en: Year 1
      nl: Jaar 1
  - id: year2
    name:
      en: Year 2
      nl: Jaar 2
  - id: rust
    name: Rust
    icon: mdiLanguageRust
  - id: library
    name: Library
    icon: mdiLibrary
